import type { PlatformInterface } from "./platform-interface";
import { PlatformSenza } from "./platform-senza";
import { PlatformBrowser } from "./platform-browser";

declare module '#app' {
  interface NuxtApp {
    $platform: PlatformInterface;
  }
}

export default defineNuxtPlugin({
  name: "platform",
  setup: nuxtApp => {
    let platform: PlatformInterface | null = null;

    if(PlatformSenza.matchThisPlatform()) {
        platform = new PlatformSenza();
    } else {
        platform = new PlatformBrowser();
    }

    nuxtApp.provide('platform', platform);
  }
});

